import cardZA from '../../assets/images/country-za.jpg'
import cardBR from '../../assets/images/country-br.jpg'
import cardIN from '../../assets/images/country-in.jpg'
import cardBY from '../../assets/images/country-by.jpg'
import cardCS from '../../assets/images/country-cs.jpg'
import cardCN from '../../assets/images/country-cn.jpg'
import cardTN from '../../assets/images/country-tn.jpg'
import cardCU from '../../assets/images/country-cu.jpg'
import cardEG from '../../assets/images/country-eg.jpg'
import cardAE from '../../assets/images/country-ae.jpg'
import cardID from '../../assets/images/country-id.jpg'
import cardAM from '../../assets/images/country-am.jpg'
import cardUZ from '../../assets/images/country-uz.jpg'

import photoZA from '../../assets/images/section-three-ZA-info.jpeg'
import photoBR from '../../assets/images/section-three-BY-info.jpg'
import photoIN from '../../assets/images/section-three-IN-info.jpg'
import photoBY from '../../assets/images/section-three-BR-info.jpg'
import photoCS from '../../assets/images/section-three-SС-info.jpeg'
import photoCN from '../../assets/images/section-three-CH-info.jpg'
import photoAM from '../../assets/images/section-three-AM-info.webp'
import photoUZ from '../../assets/images/section-three-UZ-info.webp'
import photoTN from '../../assets/images/section-three-TS-info.webp'
import photoCU from '../../assets/images/section-three-KB-info.webp'
import photoEG from '../../assets/images/section-three-EG-info.webp'
import photoAE from '../../assets/images/section-three-UAE-info.webp'
import photoID from '../../assets/images/section-three-ID-info.webp'

export interface ICountry {
  name: string;
  title: string;
  card: string;
  page: string;
  photo?: string;
  film?: string;
  text?: string;
}

export const countries: ICountry[] = [
  {
    name: 'юар',
    title: 'Южно-Африканская Республика',
    card: cardZA,
    photo: photoZA,
    page: '/africa/',
    film: 'https://vk.com/video-24199209_456302464?t=12s',
    text: 'ЮАР — самое яркое государство африканского континента. Жители Южной Африки называют себя "радужная нация". Здесь 11 официальных языков и люди всех цветов кожи уживаются под одним ярким флагом. При этом мало кто знает, но Россию и Южную Африку объединяют более 100 лет совместной истории и деловых связей.'
  },
  {
    name: 'бразилия',
    title: 'Бразилия',
    card: cardBR,
    photo: photoBR,
    page: '/brazil/',
    film: 'https://vk.com/video-24199209_456302864?t=47s',
    text: 'Бразилия — страна самбо и самбы, где первое — это название народа, а второе — естественно, танцы. На главном карнавальном шествии в этом году в ритме самбы участники буквально оттанцевали сцены из жизни созвучных потомков индейцев — самбо. Если вы не слышали о них, то точно знаете самых известных их представителей: Уго Чавеса и актера Дуэйна по прозвищу Скала. Насколько различны Бразилия и Россия по своему этническому составу, настолько схожи ментально, культурологически и даже экономически. Бразилия — наш самый западный союзник по БРИКС, но самый близкий по духу.'
  },
  {
    name: 'индия',
    title: 'Индия',
    card: cardIN,
    photo: photoIN,
    page: '/india/',
    film: 'https://vk.com/video-24199209_456303310?t=16s',
    text: 'Индия — самая многонаселённая страна мира, обогнавшая Китай, и самая многоязычная страна, говорящая на 400 наречиях. Мало кто знает, что именно по языковому принципу здесь развивается индустрия кино. Да, оказывается, это не только Болливуд, есть еще Толливуд, Колливуд, Сандалвуд, Бходжвуд, Джолливуд, Дхолливуд, Долливуд, Полливуд, Чхолливуд… и ещё много разных «вудов». В целом, Индия является для России отличным рынком по замещению западных товаров. И кто знает, может быть, совсем скоро, у нас появятся Боллинетфликс и Толлизон…'
  },
  {
    name: 'беларусь',
    title: 'Республика Беларусь',
    card: cardBY,
    photo: photoBY,
    page: '/belarus/',
    film: 'https://vk.com/video-24199209_456303769',
    text: 'Беларусь — одно из самых молодых государств. На карте Европы оно появилось в 1991 году. Беларусь сохранила почти все промышленные предприятия-гиганты советских лет, что играет немаловажную роль в экономике страны. Сегодня Россия и Беларусь составляют Союзное государство. Уже сейчас в стране разрабатываются десятки проектов как в сфере импортозамещения, так и в сфере прорывных технологий. Белорусская промышленность и российские научные технологии смогут изменить мир.'
  },
  {
    name: 'сербия',
    title: 'Сербия',
    card: cardCS,
    photo: photoCS,
    page: '/serbia/',
    film: 'https://vk.com/video-24199209_456304092',
    text: 'Сербия — страна с яркими и трагичными периодами истории: от завоевания турками в XIV веке до бомбёжек NATO в XX веке. Но, несмотря на испытания, сербы сохранили свою нацию, свой выразительный характер. Жители этой страны считают себя настоящими друзьями России, и она отвечает им тем же, развивая в Сербии энергетику и помогая восстанавливать храмы. Вместе мы насчитываем тысячу лет совместной дружбы — может, поэтому сербы называют себя малыми русскими.'
  },
  {
    name: 'китай',
    title: 'Китай',
    card: cardCN,
    photo: photoCN,
    page: '/china/',
    film: 'https://vk.com/video-24199209_456304711',
    text: 'Китай — самая древняя цивилизация на земле. В каждом китайце 5000 лет истории. А сегодня ещё и вся индустриальная мощь современного мира. В Поднебесной производят всё: от болта до паровоза. И сегодня у России с Китаем невероятно дружеские отношения. Китайцы обожают русскую культуру, восхищаются историей и с удовольствием скупают наши продукты. На международной арене государства придерживаются схожих взглядов и настаивают, что мир должен измениться и стать более справедливым.'
  },
  {
    name: 'тунис',
    title: 'Тунис',
    card: cardTN,
    photo: photoTN,
    page: '/tunis/',
    film: 'https://vkvideo.ru/video-24199209_456311327',
    text: 'Тунис — самая северная страна Африки. А для россиян одна из самых загадочных. В античные века здесь был Карфаген, который воевал с Римом за власть над миром. С Россией эту страну связывают более чем 100 лет удивительной истории. Сегодня Тунис — туристический центр. Как живут здесь россияне и как складывается сотрудничество между нашими странами?'
  },
  {
    name: 'куба',
    title: 'Куба',
    card: cardCU,
    photo: photoCU,
    page: '/kuba/',
    film: 'https://vkvideo.ru/video-24199209_456311485',
    text: 'Кубу называют Островом свободы. Все знают Фиделя Кастро и Че Гевару или слышали про сигары, ром и пляжи Варадеро. А ещё там очень любят россиян и Россию. Куба — наш союзник с советских времён. И на острове помнят об этой дружбе. Страны сохраняют исторические связи и развивают новые совместные проекты в бизнесе, промышленности и культурной сфере.',
  },
  {
    name: 'египет',
    title: 'Египет',
    card: cardEG,
    photo: photoEG,
    page: '/egypt/',
    film: 'https://vkvideo.ru/video-24199209_456311670',
    text: 'Древний Египет — первая страница во всех школьных учебниках. Этой истории 5 000 лет. Фараоны, сфинкс и пирамиды — их загадки и тайны увлекают людей по всему миру. С Россией у современного Египта крепкие союзнические отношения, которые начались со времен СССР. Сегодня в страну фараонов едут тысячи путешественников. А египтяне и россияне создают масштабные проекты, которые изменят будущее.',
  },
  {
    name: 'оаэ',
    title: 'ОАЭ',
    card: cardAE,
    photo: photoAE,
    page: '/uae/',
    film: 'https://vkvideo.ru/video-24199209_456311759',
    text: 'Сегодня Объединенные Арабские Эмираты — центр деловой жизни для всего Ближнего Востока. Современные небоскрёбы Дубая гармонично уживаются с арабскими колоритом и традициями, где до сих пор правят шейхи. Россия активно сотрудничает с ОАЭ: торговля, культура и личные связи соединяют наши страны. Восток — дело тонкое, и Россия нашла ключ для понимания его нюансов.',
  },
  {
    name: 'индонезия',
    title: 'Индонезия',
    card: cardID,
    photo: photoID,
    page: '/indonesia/',
    film: 'https://vkvideo.ru/playlist/-24199209_-2/video-24199209_456311777',
    text: 'Далекая и экзотическая Индонезия давно полюбилась российским туристам. Остров Бали стал любимым местом для тысяч путешественников. Но не только это роднит Индонезию и Россию. Здесь помнят о советской помощи, почитают Юрия Гагарина и открыты для новых совместных планов и масштабных начинаний. Индонезия стремительно превращается в надежного партнёра России в Азии.',
  },
  {
    name: 'армения',
    title: 'Армения',
    card: cardAM,
    page: '/armenia/',
    film: 'https://vkvideo.ru/video-24199209_456320060',
    photo: photoAM,
    text: 'Армения — одна из древнейших стран мира и при этом одна из самых близких России. История наших народов переплеталась веками: через веру, культуру и общие победы. Здесь знают русский язык, слушают российских артистов и учатся по российским книгам, а армянские музыканты, мастера и предприниматели давно стали частью общего культурного и делового пространства. Сегодня к этим связям добавляются новые — от торговли и образования до IT и совместных проектов. Армения кажется знакомой до мелочей, но за привычным образом скрывается страна, которую многие знают далеко не так хорошо, как думают.'
  },
  {
    name: 'узбекистан',
    title: 'Узбекистан',
    card: cardUZ,
    page: '/uzbekistan/',
    film: 'https://vkvideo.ru/video-24199209_456319730',
    photo: photoUZ,
    text: 'Узбекистан — страна, где гостя принято встречать как родного. Так было веками: через Самарканд, Бухару и Ташкент проходил Великий шёлковый путь, здесь встречались разные народы, языки и культуры. С Россией Узбекистан связывает долгая общая история — от торговли и советского прошлого до языка, образования и бизнеса. Сегодня здесь работают тысячи предприятий с российским участием, открываются филиалы российских вузов, а специалисты из двух стран вместе развивают науку, технологии и новые производства. Узбекистан бережно хранит традиции и при этом меняется очень быстро — древние города и восточные базары здесь соседствуют с современной промышленностью, технологиями и растущей экономикой.'
  },
]

export default countries
